import React from "react";

function FormSectionHeader({ icon, title, subtitle }) {
  return (
    <div className="product-form-section-header">
      <div className="product-form-section-icon">
        {icon}
      </div>
      <div>
        <h3 className="product-form-section-title text-xl font-medium">{title}</h3>
        {subtitle ? <p className="product-form-section-subtitle text-sm">{subtitle}</p> : null}
      </div>
    </div>
  );
}

export default FormSectionHeader;
